import React, { useContext } from "react";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { Clear } from "@material-ui/icons";

import ScalingContext from "../../../../../context/scaling/ScalingContext";

export default function UserCampaignFilter(props) {
  const { classes, sort, search, clearSearch } = props;

  const {
    sort_options,
    scaling_status_options,
    action_status_options,
    campaigns,
    sort_value,
    search_value,
  } = useContext(ScalingContext);

  const loading = campaigns ? false : true;

  return (
    <>
      {" "}
      {/* <Grid container alignItems="center" justifyContent="space-between"> */}{" "}
      {/* TextField: Sort Campaign */}{" "}
      <Grid item xs={2} className={classes.fieldWrapper}>
        <TextField
          variant="outlined"
          margin="dense"
          size="small"
          fullWidth
          id="sort_campaigns"
          label="Sort By"
          select
          SelectProps={{
            native: true,
          }}
          disabled={loading}
          value={sort_value}
          onChange={sort}
        >
          {sort_options.map((option) => (
            <option key={option.key} value={option.key}>
              {" "}
              {option.value}{" "}
            </option>
          ))}{" "}
        </TextField>{" "}
      </Grid>
      {/* TextField: Search Campaign By Laptop / Angle */}{" "}
      <Grid item xs className={classes.fieldWrapper}>
        <TextField
          variant="outlined"
          margin="dense"
          size="small"
          fullWidth
          id="text"
          placeholder="laptop / angle"
          disabled={loading}
          value={search_value.text}
          onChange={search}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  disabled={!search_value.text}
                  color="primary"
                  onClick={clearSearch}
                  className={classes.iconButton}
                >
                  <Clear fontSize="small" />
                </IconButton>{" "}
              </InputAdornment>
            ),
          }}
        />{" "}
      </Grid>
      {/* Status Filtering */}{" "}
      {/* Checkbox: Search Campaign By Scaling Status */}{" "}
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <FormHelperText> Scaling Status </FormHelperText>{" "}
          <FormGroup row>
            {" "}
            {scaling_status_options.map((status, index) => (
              <FormControlLabel
                key={index}
                disabled={loading}
                control={
                  <Checkbox
                    color="primary"
                    id="scaling_status"
                    name={status}
                    checked={search_value.scaling_status.includes(status)}
                    onChange={search}
                  />
                }
                label={status}
              />
            ))}{" "}
          </FormGroup>{" "}
        </FormControl>
        {/* Checkbox: Search Campaign By Action Status */}{" "}
        <FormControl component="fieldset">
          <FormHelperText> Action Status </FormHelperText>{" "}
          <FormGroup row>
            {" "}
            {action_status_options.map((status, index) => (
              <FormControlLabel
                key={index}
                disabled={loading}
                control={
                  <Checkbox
                    color="primary"
                    id="action_status"
                    name={status}
                    checked={search_value.action_status.includes(status)}
                    onChange={search}
                  />
                }
                label={status}
              />
            ))}{" "}
          </FormGroup>{" "}
        </FormControl>{" "}
      </Grid>{" "}
      {/* </Grid> */}{" "}
    </>
  );
}
